import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RevShareModal from "../../../common/overrides/RevShareModal";
import Note from "./Note";
import AddNoteModal from "./AddNoteModal";
import { Col, Row, Container } from "react-bootstrap";
import { loadAvailableHoursNotes } from "../../../../redux/actions/AvailableHoursActions";

class AvailableHoursNotesModal extends React.Component {
  render() {
    return (
      <RevShareModal
        buttonText="Notes"
        buttonVariant="primary"
        hideYesButton
        noButtonText="Close"
        noButtonVariant="secondary"
        title="Available Hours Notes"
      >
        <Container>
          <Row>
            <Col />
            <Col xs="auto">
              <AddNoteModal availableHoursId={this.props.AvailableHoursRecord.id} />
            </Col>
            <Col />
          </Row>
          {this.props.notes[this.props.AvailableHoursRecord.id] !== undefined ? (
            this.props.notes[this.props.AvailableHoursRecord.id]
              .sort((a, b) => b.id - a.id)
              .map((note) => <Note note={note} />)
          ) : (
            <Row>
              <p>There are no notes associated with these hours.</p>
            </Row>
          )}
        </Container>
      </RevShareModal>
    );
  }

  componentDidMount() {
    this.props.getNotes(this.props.AvailableHoursRecord.id);
  }
}

AvailableHoursNotesModal.propTypes = {
  AvailableHoursRecord: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return { notes: state.availableHoursNotes };
}

const mapDispatchToProps = {
  getNotes: loadAvailableHoursNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableHoursNotesModal);
